/**
 * Model configuration
 */
export const config = {
  modelName: 'dictionaries',
} as const;
